import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemConfig } from '@arema/types/admin';
import { Button, Dropdown, Groupper, Header, Input, Modal, useFrontier } from 'react-frontier2';
import { useAPI, useTitle } from '@arema/components/Hooks';
import { SetLoading } from '@arema/components/Classes';
import { bindClick, bindFormChange, roundNumber } from '@arema/components/Util';
import API from '../../API';

var SysConfig = ()=>{
	var { Toast } = useFrontier();
	var { setTitle } = useTitle();
	var { t } = useTranslation();
	var [modal, setModal] = useState<boolean>(false);
	var { load, data, loadError, setData } = useAPI(API.getSystemConfig);

	useEffect(()=>{
		if(!data) load();
		setTitle('Config');
	}, []);

	var saveConfig = (setLoading: SetLoading)=>{
		setLoading(true);
		API.setSystemConfig(data).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success(t('config.saved'))
		}).catch(err=>{
			return Toast.error(t('common.unexpected_code', { code: 'LCL-SYSCNF' }));
		}).finally(()=>{
			setLoading(false);
		})
	}

	var onDataChange = bindFormChange(data as SystemConfig, setData);

	if(loadError) return <Header text={t('common.error')} subtext={loadError} />
	if(!data) return <Header text={t('common.loading')} loading />
	
	return <>
		<Groupper style={{ maxWidth: 500 }} title={t('config.title')} actions={(
			<Button text={t('common.save')} onClick={saveConfig} color={'black'} />
		)}>
			<div className="fr option">
				<div className="info">
					<div className="title">{t('config.openpay.title')}</div>
					<div className="description">{t('config.openpay.description')}</div>
				</div>
				<Dropdown style={{ width: 100 }} value={data.openpay_chance} onValueChange={onDataChange('openpay_chance')} items={(
					new Array(11).fill(0).map((a,i)=>({
						text: `${i*10}%`,
						value: roundNumber(i/10)
					}))
				)} />
			</div>
		</Groupper>
		<Button basic text='Raw' onClick={bindClick(setModal, true)} style={{ display: 'block', width: 150, margin: 'auto', marginTop: 15 }} />
		<Modal open={modal} onClose={bindClick(setModal)}>
			<Modal.Header text='Raw' />
			<Modal.Content>
				<pre>{JSON.stringify(data, null, 3)}</pre>
			</Modal.Content>
		</Modal>
	</>
}

export default SysConfig;